import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { CelebrationService } from '../celebration/celebration.service';
import { UsersCacheService } from 'src/app/services/cache/users-cache';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-enrollment-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSelectModule,
  ],
  template: `
    <div class="enrollment-modal">
      <h2 mat-dialog-title>{{ data?.title || 'Start Date' }}</h2>
      <mat-dialog-content>
        <form [formGroup]="form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="start_at" required>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="form.get('start_at')?.hasError('required')">
              Start date is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>FAFSA Advisor</mat-label>
            <mat-select formControlName="fa_advisor_id">
              <mat-option [value]="null">None</mat-option>
              <mat-option *ngFor="let user of users" [value]="user.id">
                {{ user.name }} {{ user.lastName }}
              </mat-option>
            </mat-select>
            <mat-hint>Select user that helped with FA process</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Note (optional)</mat-label>
            <textarea matInput formControlName="note" rows="3" placeholder="Add a note..."></textarea>
          </mat-form-field>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="onClose()">Cancel</button>
        <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="!form.valid">
          {{ data?.submitLabel || 'Save' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .enrollment-modal { padding: 8px; }
    .full-width { width: 100%; }
    mat-dialog-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      min-width: 350px;
      padding-top: 20px !important;
      overflow: visible !important;
    }
    mat-dialog-actions { padding-top: 8px; }
  `]
})
export class EnrollmentModalComponent implements OnInit {
  form: FormGroup;
  users: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EnrollmentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private celebrationService: CelebrationService,
    private usersCacheService: UsersCacheService,
  ) {
    console.log(this.data,'fskmfskmsfkm')
    this.form = this.fb.group({
      start_at: [data?.start_at || '', Validators.required],
      note: [data?.note || ''],
      fa_advisor_id: [data?.fa_advisor_id || null],
    });
  }

  async ngOnInit(): Promise<void> {
    this.usersCacheService.fetchData();
    const userCache = await firstValueFrom(this.usersCacheService.data$);
    this.users = userCache.filter((u: any) => u.active);
  }

  onSubmit(): void {
    if (this.form.valid) {
      if (this.data?.mode === 'enroll') {
        this.celebrationService.celebrateEnrolled();
      }
      this.dialogRef.close(this.form.value);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}